<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex space-x-4">
				<div class="text-left flex w-full">
					<div v-if="!isLoading">
						<div class="w-full">
							<div class="flex font-bold" style="font-size: 20px">{{ $t('one_time_options') }}</div>
							<div class="flex grid grid-cols-3 mt-4 gap-x-8 gap-y-2" v-if="variablesOnce">
								<CompanyVariable
									:title="$t('transport_service_landlord')"
									:variable="variable"
									:required="true"
									v-for="variable in variablesOnce"
									:key="variable.id"
									:ref="'variables_once_' + variable.id"
								/>
							</div>
						</div>
						<div class="w-full">
							<div class="mt-8 flex font-bold" style="font-size: 20px">{{ $t('options_with_daily_costs') }}</div>
							<div class="flex grid grid-cols-3 mt-4 gap-x-8 gap-y-2" v-if="variables">
								<CompanyVariable
									:title="$t('transport_service_landlord')"
									:variable="variable"
									:required="true"
									v-for="variable in variables"
									:key="variable.id"
									:ref="'variables_' + variable.id"
								/>
							</div>
							<div class="mt-4" v-if="variableCustom">
								<div class="flex w-full font-bold mb-2" style="color: #495057">{{ $t('customizable_input_field') }}</div>
								<div class="flex flex-row">
									<BaseInput v-model="variableCustom.label" @input="$emit('input')" ref="text" class="w-1/3 pr-5" :required="false" />
									<BaseInputNumber v-model="variableCustom.value" ref="number" class="w-1/3 pl-3" :precision="2" :required="false" />
								</div>
							</div>
						</div>
					</div>
					<LoadingSpinner v-else />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import CompanyVariable from '@/views/usermanagment/CompanyVariable.vue';
import RentalCarExtraCostsRepository from '@/api/repositories/RentalCarExtraCostsRepository';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import Validate from '@/mixins/Validate';

export default {
	components: { BaseInput, CompanyVariable, LoadingSpinner, BaseInputNumber },
	name: 'OnboardingCompanyRentalCarsExtraCosts',
	mixins: [Validate],
	props: {
		value: {},
	},
	data() {
		return {
			isLoading: false,
			variables: [],
			variablesOnce: [],
			variableCustom: null,
		};
	},
	mounted() {
		this.isLoading = true;
		this.getRentalCarExtraCosts();
	},
	methods: {
		getRentalCarExtraCosts() {
			this.isLoadingExtras = true;
			new RentalCarExtraCostsRepository()
				.getAll(false)
				.then(response => {
					this.variables = response.data.daily.filter(variable => !variable.key.includes('custom_field'));
					this.variablesOnce = response.data.once;
					if (!response.data.daily.find(variable => variable.key.includes('custom_field'))) {
						this.variableCustom = { id: null, key: 'custom_field', label: '', value: null, type: 'number' };
					} else {
						this.variableCustom = response.data.daily.find(variable => variable.key.includes('custom_field'));
					}
					this.isLoading = false;
				})
				.catch(e => {
					this.isLoading = false;
					console.log(e);
				});
		},
		getData() {
			if (!this.variableCustom.value || isNaN(this.variableCustom.value)) {
				if (this.variableCustom.label) {
					this.$swal(this.$t('general.error').toString(), this.$t('custom_field_error').toString(), 'error');
					return null;
				} else {
					this.variableCustom.value = null;
				}
			} else if (!this.variableCustom.label) {
				this.$swal(this.$t('general.error').toString(), this.$t('custom_field_label_error').toString(), 'error');
				return null;
			}
			if (this.variableCustom.label === '0') {
				this.variableCustom.value = null;
				this.variableCustom.label = '';
			}

			const rentalCarExtraCosts = this.variablesOnce.concat(this.variables, [this.variableCustom]);
			return { extraCosts: rentalCarExtraCosts };
		},
	},
};
</script>
